import { render } from "./preview-item.vue?vue&type=template&id=cb955e78&ts=true"
import script from "./preview-item.vue?vue&type=script&lang=tsx"
export * from "./preview-item.vue?vue&type=script&lang=tsx"

import exportComponent from "/var/lib/jenkins/workspace/OfferCloud2_FrontWebs_All/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__